import { render, staticRenderFns } from "./PatientPortal.vue?vue&type=template&id=3722f6ce&"
import script from "./PatientPortal.vue?vue&type=script&lang=js&"
export * from "./PatientPortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports